import axios from 'axios'
import router from '@/router'
import { getToken, removeToken } from '@/utils/auth'
import EventBus from '@/utils/eventHub.js'
// export const apiBaseURL = 'http://192.168.3.67:8080/renren-admin'
export const apiBaseURL = 'https://huanruan.com/admin-api/'

// create an axios instance
const service = axios.create({
  // : process.env.VUE_APP_BASE_API
  baseURL: apiBaseURL
})
// request interceptor
service.interceptors.request.use(
  config => {
    // axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // do something before request is sent
    if (getToken()) {
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.data.code === 0 || response.data.code === 200) {
      const res = response.data
	  EventBus.$emit('loadFinished', true)
      // console.log('响应结果(response.data):' + res)
      // console.log('响应消息(response.msg):' + response.msg)
      return res
    } else if (response.data.code === 401) {
      // 超时，重新登陆
      // router.push('/login')
	  removeToken()
	  EventBus.$emit('isLogin', false)
    } else {
      const res = response.data
      return res
    }
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

export default service
